<!-- icono de dirección: teléfono con la flecha de sentido, como en el histórico de eventos del expediente -->
<ng-template #directionIcon let-call>
  <span class="event-icon">
    <i class="pi pi-phone"></i>
    <i *ngIf="call.direction === 'In'" class="pi pi-arrow-down-left top-icon top-icon-red"></i>
    <i *ngIf="call.direction === 'Out'" class="pi pi-arrow-up-right top-icon top-icon-green"></i>
    <i *ngIf="call.direction === 'Internal'" class="pi pi-arrows-h top-icon top-icon-grey"></i>
  </span>
</ng-template>

<app-filter-panel [fields]="fieldsConfig" [quickSearchFilter]="filters.caseNumber"
  quickSearchPlaceholder="Expediente" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
  <div class="input-field">
    <p-calendar [(ngModel)]="filters.startFrom.value" [showTime]="true" [firstDayOfWeek]="1" [showIcon]="true"
      [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" appendTo="body" />
  </div>
  <div class="input-field">
    <p-calendar [(ngModel)]="filters.startTo.value" [showTime]="true" [firstDayOfWeek]="1" [showIcon]="true"
      [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" appendTo="body" />
  </div>
  <span class="input-field p-input-icon-right">
      <input pInputText placeholder="Tel. origen" [(ngModel)]="filters.srcNumber.value"  class="w-full" />
      <i *ngIf="filters.srcNumber.value" class="pi pi-times cursor-pointer" (click)="filters.srcNumber.value = null;"></i>
  </span>
  <span class="input-field p-input-icon-right">
      <input pInputText placeholder="Tel. destino" [(ngModel)]="filters.dstNumber.value"  class="w-full" />
      <i *ngIf="filters.dstNumber.value" class="pi pi-times cursor-pointer" (click)="filters.dstNumber.value = null;"></i>
  </span>
  <div class="input-field" style="width: 200px;">
      <p-dropdown placeholder="Usuario origen" [options]="userOptions" optionLabel="name" optionValue="value"
          [(ngModel)]="filters.originUser.value" showClear [filter]="true" filterBy="name" appendTo="body" />
  </div>
  <div class="input-field" style="width: 200px;">
      <p-dropdown placeholder="Usuario destino" [options]="userOptions" optionLabel="name" optionValue="value"
          [(ngModel)]="filters.answeredByUser.value" showClear [filter]="true" filterBy="name" appendTo="body" />
  </div>
  <div class="input-field" style="width: 170px;">
      <p-dropdown placeholder="Estado" [options]="statuses" optionLabel="label" optionValue="value"
          [(ngModel)]="filters.status.value"  showClear />
  </div>
  <div class="input-field" style="width: 170px;">
      <p-dropdown placeholder="Dirección" [options]="directions" optionLabel="label" optionValue="value"
          [(ngModel)]="filters.direction.value"  showClear />
  </div>
  <div class="input-field" style="width: 170px;">
      <p-dropdown placeholder="Tipo de llamada" [options]="callTypeOptions" optionLabel="label" optionValue="value"
          [(ngModel)]="filters.callType.value"  showClear />
  </div>
  <span class="input-field p-input-icon-right">
      <input pInputText placeholder="Cola" [(ngModel)]="filters.queueName.value" (keydown.enter)="search()" class="w-full" />
      <i *ngIf="filters.queueName.value" class="pi pi-times cursor-pointer" (click)="filters.queueName.value = null;"></i>
  </span>
  <span class="input-field p-input-icon-right">
      <input pInputText placeholder="Expediente" [(ngModel)]="filters.caseNumber.value" (keydown.enter)="search()" class="w-full" />
      <i *ngIf="filters.caseNumber.value" class="pi pi-times cursor-pointer" (click)="filters.caseNumber.value = null;"></i>
  </span>
  <span class="input-field p-input-icon-right">
      <input pInputText placeholder="Call ID" [(ngModel)]="filters.linkedId.value" (keydown.enter)="search()" class="w-full" />
      <i *ngIf="filters.linkedId.value" class="pi pi-times cursor-pointer" (click)="filters.linkedId.value = null;"></i>
  </span>
  <div class="input-field flex">
        <button pButton  label="Buscar" icon="pi pi-search" (click)="search()"></button>
        <button pButton ngClass="ml-2" label="Limpiar" icon="pi pi-eraser" (click)="resetFilters()" severity="secondary" ></button>
    </div>
</div>
-->

<p-table #grid [value]="calls" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
      <tr>
          <th pSortableColumn="start">Fecha <p-sortIcon field="start"></p-sortIcon></th>
          <th pSortableColumn="direction">Dirección <p-sortIcon field="direction"></p-sortIcon></th>
          <th pSortableColumn="caseNumber">Expediente <p-sortIcon field="caseNumber"></p-sortIcon></th>
          <th pSortableColumn="callType">Tipo <p-sortIcon field="callType"></p-sortIcon></th>
          <th pSortableColumn="status">Estado <p-sortIcon field="status"></p-sortIcon></th>
          <th pSortableColumn="queueName">Cola <p-sortIcon field="queueName"></p-sortIcon></th>
          <th pSortableColumn="srcNumber">Tel. origen <p-sortIcon field="srcNumber"></p-sortIcon></th>
          <th pSortableColumn="dstNumber">Tel. destino <p-sortIcon field="dstNumber"></p-sortIcon></th>
          <th pSortableColumn="totalDurationSec">Duración <p-sortIcon field="totalDurationSec"></p-sortIcon></th>
          <th width="220">Grabación</th>
          <th width="120"></th>
      </tr>
  </ng-template>
  <ng-template pTemplate="body" let-call let-columns="columns">
      <tr>
          <td>{{call.start | date:'dd/MM/yyyy HH:mm:ss'}}</td>
          <td class="white-space-nowrap"><ng-container *ngTemplateOutlet="directionIcon; context: {$implicit: call}"></ng-container> {{getDirectionLabel(call)}}</td>
          <td><a *ngIf="call.caseId" (click)="goToCase(call.caseId)">{{call.caseNumber}}</a></td>
          <td>{{getCallTypeLabel(call)}}</td>
          <td>
            <p-tag [value]="getStatusLabel(call)" [severity]="getStatusSeverity(call)"></p-tag>
          </td>
          <td>{{call.queueName || '-'}}</td>
          <td>
            {{call.srcNumber}}
            <br *ngIf="call.srcName"><small *ngIf="call.srcName">{{call.srcName}}</small>
          </td>
          <td>
            {{call.dstNumber}}
            <br *ngIf="call.dstName"><small *ngIf="call.dstName">{{call.dstName}}</small>
          </td>
          <td>
            {{formatSeconds(call.totalDurationSec)}}
            <br *ngIf="call.talkSec > 0"><small *ngIf="call.talkSec > 0">{{formatSeconds(call.talkSec)}} conversación</small>
          </td>
          <td>
            <ng-container *ngIf="hasRecording(call)">
              <p-button *ngIf="!call.showRecording" (click)="call.showRecording = !call.showRecording"><i class="pi pi-play-circle"></i>&nbsp; Reproducir</p-button>
              <audio *ngIf="call.showRecording" controls>
                  <source src="{{getRecordingUrl(call)}}" type="audio/mpeg">
                  Tu navegador no soporta reproducción de audio
              </audio>
            </ng-container>
            <span *ngIf="!hasRecording(call)">-</span>
          </td>
          <td>
            <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="call.caseId" [pTooltip]="'Ver expediente'" tooltipPosition="top" (click)="goToCase(call.caseId)" [rounded]="true" [text]="false"><i class="pi pi-clipboard"></i></p-button>
                <p-button [pTooltip]="'Ver detalle'" tooltipPosition="top" (click)="openDetail(call)" [rounded]="true" [text]="false"><i class="pi pi-eye"></i></p-button>
            </div>
          </td>
      </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="11">
           No se han encontrado llamadas
        </td>
      </tr>
    </ng-template>
</p-table>

<p-dialog header="Detalle de la llamada" [(visible)]="detailVisible" [modal]="true" [style]="{width: '640px'}" [dismissableMask]="true">
  <div *ngIf="selectedCall" class="flex flex-column gap-3">
    <div class="grid detail-grid">
      <div class="col-6"><strong>Estado:</strong> <p-tag [value]="getStatusLabel(selectedCall)" [severity]="getStatusSeverity(selectedCall)"></p-tag></div>
      <div class="col-6"><strong>Tipo:</strong> {{getCallTypeLabel(selectedCall)}}</div>
      <div class="col-6"><strong>Dirección:</strong> <ng-container *ngTemplateOutlet="directionIcon; context: {$implicit: selectedCall}"></ng-container> {{getDirectionLabel(selectedCall)}}</div>
      <div class="col-6" *ngIf="selectedCall.queueName"><strong>Cola:</strong> {{selectedCall.queueName}}</div>
      <div class="col-6"><strong>Origen:</strong> {{selectedCall.srcName || selectedCall.srcNumber || '-'}}</div>
      <div class="col-6"><strong>Destino:</strong> {{selectedCall.dstName || selectedCall.dstNumber || '-'}}</div>
      <div class="col-6" *ngIf="selectedCall.answeredByAgent"><strong>Atendida por:</strong> {{selectedCall.answeredByAgent}}</div>
      <div class="col-6"><strong>Inicio:</strong> {{selectedCall.start | date:'dd/MM/yyyy HH:mm:ss'}}</div>
      <div class="col-6"><strong>Duración total:</strong> {{formatSeconds(selectedCall.totalDurationSec)}}</div>
      <div class="col-6" *ngIf="selectedCall.talkSec > 0"><strong>Conversación:</strong> {{formatSeconds(selectedCall.talkSec)}}</div>
      <div class="col-6" *ngIf="selectedCall.waitSec > 0"><strong>Espera:</strong> {{formatSeconds(selectedCall.waitSec)}}</div>
      <div class="col-6" *ngIf="selectedCall.caseNumber"><strong>Expediente:</strong> <a (click)="goToCase(selectedCall.caseId!)">{{selectedCall.caseNumber}}</a></div>
      <div class="col-12"><strong>Call ID:</strong> {{selectedCall.linkedId}}</div>
    </div>

    <div>
      <h3 style="margin-top: 5px;">Cronología</h3>
      <div *ngIf="loadingTimeline">Cargando…</div>
      <p-timeline *ngIf="!loadingTimeline && timeline.length > 0" [value]="timeline" styleClass="call-timeline">
        <ng-template pTemplate="opposite" let-ev>
          <div class="call-timeline-time">{{ev.at | date:'HH:mm:ss'}}</div>
          <small class="call-timeline-offset">+{{formatSeconds(timelineOffset(ev))}}</small>
        </ng-template>
        <ng-template pTemplate="marker" let-ev>
          <span class="call-timeline-marker" [style.background-color]="timelineColor(ev)">
            <i [class]="timelineIcon(ev)"></i>
          </span>
        </ng-template>
        <ng-template pTemplate="content" let-ev>
          <div class="call-timeline-text" [class.call-timeline-key]="ev.kind === 'answered' || ev.kind === 'external-answered' || ev.kind === 'abandoned'">{{ev.text}}</div>
        </ng-template>
      </p-timeline>
      <div *ngIf="!loadingTimeline && timeline.length === 0">Sin eventos.</div>
    </div>

    <div *ngIf="hasRecording(selectedCall)">
      <h3 style="margin-top: 5px;">Grabación</h3>
      <p-button *ngIf="!playDetailRecording" (click)="playDetailRecording = true"><i class="pi pi-play-circle"></i>&nbsp; Reproducir</p-button>
      <audio *ngIf="playDetailRecording" controls autoplay>
        <source src="{{getRecordingUrl(selectedCall)}}" type="audio/mpeg">
        Tu navegador no soporta reproducción de audio
      </audio>
    </div>
  </div>
</p-dialog>
